module.exports = __webpack_public_path__ + "staticcomp/img/content_3.68b2cab.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/3/5/content_3.jpg
// module id = 7Dyg
// module chunks = 39